export const en = {
  components: {
    datePicker: {
      openCalendar: 'Open Calendar',
      clear: 'Clear date range',
    },
    dataGrid: {
      selectAll: 'Select All',
      selectRow: 'Select Row',
      noData: 'No data available',
      error: 'Error loading data',
      errorDescription: 'Please try again in a few minutes',
    },
    select: {
      noOptions: 'No options found',
    },
    sidecarSelector: {
      label: 'Sidecar',
      noSelection: 'No sidecar selected',
      online: '[online]',
      offline: '[offline]',
      connecting: 'Connecting',
      direct: 'Direct',
      relay: 'Relay',
      disconnected: 'Disconnected',
    },
    cameraStream: {
      loading: 'Connecting...',
      unavailable: 'Stream unavailable',
      menuLabel: 'Stream options',
      ptz: {
        left: 'Pan Left',
        right: 'Pan Right',
        up: 'Tilt Up',
        down: 'Tilt Down',
        zoomIn: 'Zoom In',
        zoomOut: 'Zoom Out',
      },
      floodlight: {
        on: 'Floodlight On',
        off: 'Floodlight Off',
      },
      siren: {
        trigger: 'Trigger Siren',
      },
    },
    loading: 'Loading...',
    saving: 'Saving...',
    saved: 'Updates saved',
    photoCard: {
      uploading: 'Uploading...',
      uploadFailed: 'Upload Failed',
      noImage: 'No Image',
    },
  },
};
